import React, { useState } from "react";
import "./AdmissionForm.css";
import qrImage from "../../assets/qr-code.jpg";

const AdmissionForm = ({ headingLevel = "h2" }) => {
  const initialFormState = {
    email: "",
    fullName: "",
    fatherName: "",
    occupation: "",
    contact: "",
    altContact: "",
    dob: "",
    course: "",
    address: "",
    source: ""
  };

  const [formData, setFormData] = useState(initialFormState);
  const [fileData, setFileData] = useState({});
  const [showQRPopup, setShowQRPopup] = useState(false);
  const [showBankPopup, setShowBankPopup] = useState(false);
  const Heading = headingLevel;

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (files) {
      // Store file data separately
      setFileData({
        ...fileData,
        [name]: files[0]
      });
    } else {
      // Store regular form data
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    
    // Append text form data
    Object.keys(formData).forEach(key => {
      if (formData[key]) {
        form.append(key, formData[key]);
      }
    });
    
    // Append file data
    Object.keys(fileData).forEach(key => {
      if (fileData[key]) {
        form.append(key, fileData[key]);
      }
    });

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admission/admission`, {
        method: "POST",
        body: form,
      });

      const data = await res.json();

      if (data.success) {
        alert("Form submitted! Enrollment ID: " + data.enrollmentId);
        // Reset form after successful submission
        setFormData(initialFormState);
        setFileData({});
        // Reset file inputs
        document.querySelectorAll('input[type="file"]').forEach(input => {
          input.value = "";
        });
      } else {
        alert("Error submitting form.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting form. Please try again.");
    }
  };

  return (
    <div className="admission-form-wrapper" id="ad-form">
      <Heading className="af-title">Nursery Teacher Training Course Admission</Heading>
      <p className="af-subtitle">
        Fill in this Application Form for the course with National Institute of Early Child Care Education. We offer Diploma in Nursery Education (NTT), NTT with Montessori integrated.
      </p>

      {/* QR Code and Bank Details Buttons */}
      <div className="af-action-buttons">
        <button 
          type="button" 
          className="af-qr-btn"
          onClick={() => setShowQRPopup(true)}
        >
          View QR Code for Payment
        </button>
        <button 
          type="button" 
          className="af-bank-btn"
          onClick={() => setShowBankPopup(true)}
        >
          View Bank Details
        </button>
      </div>

      {/* QR Code Popup */}
      {showQRPopup && (
        <div className="af-popup-overlay">
          <div className="af-popup">
            <div className="af-popup-header">
              <h3>Scan QR Code for Payment</h3>
              <button 
                className="af-popup-close"
                onClick={() => setShowQRPopup(false)}
              >
                &times;
              </button>
            </div>
            <div className="af-popup-content">
              <div className="af-qr-placeholder">
                <div className="af-qr-code">
                  <img
                    src={qrImage}
                    alt="NIECCE admission payment QR code"
                    title="NIECCE admission payment QR code"
                    className="ap-qr-image"
                  />
                  <p>Scan this QR code to make payment</p>
                </div>
              </div>
              <div className="af-popup-instructions">
                <h4>Instructions:</h4>
                <ol>
                  <li>Scan the QR code using any UPI app</li>
                  <li>Enter amount: ₹500</li>
                  <li>Add remark: "Admission Fee"</li>
                  <li>Complete the payment</li>
                  <li>Take screenshot and upload below</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bank Details Popup */}
      {showBankPopup && (
        <div className="af-popup-overlay">
          <div className="af-popup">
            <div className="af-popup-header">
              <h3>Bank Account Details</h3>
              <button 
                className="af-popup-close"
                onClick={() => setShowBankPopup(false)}
              >
                &times;
              </button>
            </div>
            <div className="af-popup-content">
              <div className="af-bank-details-popup">
                <div className="af-bank-info">
                  <h4>For Net Banking / NEFT / RTGS</h4>
                  <div className="af-bank-card">
                    <p><strong>Bank Name:</strong> HDFC Bank</p>
                    <p><strong>Account Name:</strong> NIECCE EDU SOLUTIONS PVT LTD</p>
                    <p><strong>Account Number:</strong> 50200084844568</p>
                    <p><strong>Account Type:</strong> Current Account</p>
                    <p><strong>IFSC Code:</strong> HDFC0001757</p>
                    <p><strong>Branch:</strong> [Branch Name]</p>
                  </div>
                </div>
                <div className="af-payment-instructions">
                  <h4>Payment Instructions:</h4>
                  <ul>
                    <li>Transfer amount: ₹500</li>
                    <li>Use your name as reference</li>
                    <li>Keep transaction ID/UTR number</li>
                    <li>Take screenshot of successful transaction</li>
                    <li>Upload the screenshot below</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <form className="af-form" onSubmit={handleSubmit}>
        {/* Personal Details */}
        <label className="af-label">
          Email *
          <input 
            type="email" 
            name="email" 
            className="af-input" 
            required 
            onChange={handleChange}
            value={formData.email}
          />
        </label>

        <label className="af-label">
          Your Full Name (To Print in Certificate) *
          <input 
            type="text" 
            name="fullName" 
            className="af-input" 
            required 
            onChange={handleChange}
            value={formData.fullName}
          />
        </label>

        <label className="af-label">
          Father / Husband Name *
          <input 
            type="text" 
            name="fatherName" 
            className="af-input" 
            required 
            onChange={handleChange}
            value={formData.fatherName}
          />
        </label>

        <label className="af-label">
          Past Occupation (if any)
          <input 
            type="text" 
            name="occupation" 
            className="af-input" 
            onChange={handleChange}
            value={formData.occupation}
          />
        </label>

        <label className="af-label">
          Contact Number (WhatsApp no.) *
          <input 
            type="tel" 
            name="contact" 
            className="af-input" 
            required 
            onChange={handleChange}
            value={formData.contact}
          />
        </label>

        <label className="af-label">
          Alternate Contact Number
          <input 
            type="tel" 
            name="altContact" 
            className="af-input" 
            onChange={handleChange}
            value={formData.altContact}
          />
        </label>

        <label className="af-label">
          Date of Birth *
          <input 
            type="date" 
            name="dob" 
            className="af-input" 
            required 
            onChange={handleChange}
            value={formData.dob}
          />
        </label>

        {/* Course Selection */}
        <label className="af-label">
          Select Course *
          <select
            name="course"
            className="af-select"
            required
            onChange={handleChange}
            value={formData.course}
          >
            <option value="">Select Course</option>
            <option value="NTT">NTT (Nursery Teacher Training)</option>
            <option value="MTT">MTT (Montessori Teacher Training)</option>
            <option value="PTT">PTT (Primary Teacher Training)</option>
          </select>
        </label>

        {/* File Uploads with Styled Buttons */}
        <FileUpload
          label="Upload your Aadhar Card *"
          name="aadhar"
          required
          fileData={fileData}
          handleChange={handleChange}
        />
        <FileUpload
          label="Upload your 10th Standard Certificate *"
          name="tenth"
          required
          fileData={fileData}
          handleChange={handleChange}
        />
        <FileUpload
          label="Upload your 12th Standard / PUC Certificate (If Any)"
          name="twelfth"
          fileData={fileData}
          handleChange={handleChange}
        />
        <FileUpload
          label="Upload your Graduation Convocation Certificate (If Any)"
          name="grad"
          fileData={fileData}
          handleChange={handleChange}
        />
        <FileUpload
          label="Upload PG Convocation / All Other Certifications (If Any)"
          name="pgCert"
          fileData={fileData}
          handleChange={handleChange}
        />
        <FileUpload
          label="Upload your Photograph (with a plain/white background) *"
          name="photo"
          required
          fileData={fileData}
          handleChange={handleChange}
        />
        
        {/* Payment Upload Section with Buttons */}
        <div className="af-upload-section">
          <div className="af-upload-header">
            <h4>Payment Screenshot Upload</h4>
            <p className="af-payment-note">
              Application Fee: <strong>₹500/-</strong> • After payment, upload screenshot
            </p>
          </div>
          
          <div className="af-payment-buttons">
            <button 
              type="button" 
              className="af-payment-btn"
              onClick={() => setShowQRPopup(true)}
            >
              QR Code
            </button>
            <button 
              type="button" 
              className="af-payment-btn"
              onClick={() => setShowBankPopup(true)}
            >
              Bank Details
            </button>
          </div>
          
          <FileUpload
            label="Upload Screenshot after Payment"
            name="paymentScreenshot"
            fileData={fileData}
            handleChange={handleChange}
          />
        </div>

        <label className="af-label">
          Your Full Address (for correspondence) *
          <textarea 
            name="address" 
            className="af-textarea" 
            required 
            onChange={handleChange}
            value={formData.address}
          ></textarea>
        </label>

        <label className="af-label">
          How do you know about your institute? *
          <select 
            name="source" 
            className="af-select" 
            required 
            onChange={handleChange}
            value={formData.source}
          >
            <option value="">Select</option>
            <option value="Old Student Reference">Old Student Reference</option>
            <option value="Principal/Teacher in a school">Principal/Teacher in a school</option>
            <option value="Google Search">Google Search</option>
            <option value="Just Dial / Sulekha">Just Dial / Sulekha</option>
            <option value="Newspaper / TV">Newspaper / TV</option>
            <option value="NIECCE Website">NIECCE Website</option>
            <option value="Seminar / Webinar / Workshop">Seminar / Webinar / Workshop</option>
            <option value="Other">Other</option>
          </select>
        </label>

        <p className="af-fee-note">
          APPLICATION FEE IS Rs.500/- <br />
          AFTER TRANSFER, SHARE THE ACKNOWLEDGEMENT RECEIPT TO OUR REPRESENTATIVE FOR GENERATING OF PAYMENT RECEIPT.
        </p>

        <div className="af-bank-details">
          <h4>Bank Account Details for Net Banking</h4>
          <p>
            HDFC Bank <br />
            A/c Name: NIECCE EDU SOLUTIONS PVT LTD <br />
            A/c No.: 50200084844568 <br />
            Current Account <br />
            IFSC CODE: HDFC0001757
          </p>
        </div>

        <button type="submit" className="af-submit-btn">
          Submit Application
        </button>
      </form>
    </div>
  );
};

// Reusable File Upload Component
const FileUpload = ({ label, name, required, fileData, handleChange }) => {
  return (
    <label className="af-label">
      {label}
      <input
        type="file"
        name={name}
        id={name}
        className="af-input-file"
        required={required}
        onChange={handleChange}
      />
      <label htmlFor={name} className="af-upload-btn">
        Choose File
      </label>
      {fileData[name] && (
        <span className="af-file-name">{fileData[name].name}</span>
      )}
    </label>
  );
};

export default AdmissionForm;
